import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const HOBBIES_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: [
    'Badminton',
    'Basketball',
    'Coding',
    'Cooking',
    'Crafting',
    'Cricket',
    'Dancing',
    'Football',
    'Gardening',
    'Handicraft',
    'Hiking',
    'Listening to Music',
    'Painting',
    'Photography',
    'Playing Video Games',
    'Reading',
    'Singing',
    'Sports',
    'Tennis',
    'Traveling',
    'Trekking',
    'Volunteering',
    'Watching Movies',
    'Working out',
    'Writing',
    'Yoga',
  ],
  [SupportedLanguage.Hindi]: [
    'बैडमिंटन',
    'बास्केटबॉल',
    'कोडिंग',
    'खाना बनाना',
    'शिल्पकारी',
    'क्रिकेट',
    'नृत्य',
    'फुटबॉल',
    'बागवानी',
    'हस्तशिल्प',
    'पैदल यात्रा',
    'संगीत सुनना',
    'चित्रकला',
    'फोटोग्राफी',
    'वीडियो गेम खेलना',
    'पढ़ना',
    'गाना',
    'खेल',
    'टेनिस',
    'यात्रा करना',
    'ट्रेकिंग',
    'स्वयंसेवा',
    'फिल्में देखना',
    'व्यायाम करना',
    'लेखन',
    'योग',
  ],
  [SupportedLanguage.Marathi]: [
    'बॅडमिंटन',
    'बास्केटबॉल',
    'कोडिंग',
    'स्वयंपाक',
    'शिल्पकला',
    'क्रिकेट',
    'नृत्य',
    'फुटबॉल',
    'बागकाम',
    'हस्तकला',
    'पायी भटकंती',
    'संगीत ऐकणे',
    'चित्रकला',
    'फोटोग्राफी',
    'व्हिडिओ गेम खेळणे',
    'वाचन',
    'गाणे',
    'खेळ',
    'टेनिस',
    'प्रवास',
    'ट्रेकिंग',
    'स्वयंसेवा',
    'चित्रपट पाहणे',
    'व्यायाम',
    'लेखन',
    'योग',
  ],
  [SupportedLanguage.Gujarati]: [
    'બેડમિન્ટન',
    'બાસ્કેટબોલ',
    'કોડિંગ',
    'રસોઈ',
    'ક્રાફ્ટિંગ',
    'ક્રિકેટ',
    'નૃત્ય',
    'ફૂટબોલ',
    'બાગકામ',
    'હસ્તકલા',
    'હાઇકિંગ',
    'સંગીત સાંભળવું',
    'ચિત્રકામ',
    'ફોટોગ્રાફી',
    'વિડિઓ ગેમ્સ રમવા',
    'વાંચન',
    'ગાયન',
    'રમતો',
    'ટેનિસ',
    'મુસાફરી',
    'ટ્રેકિંગ',
    'સ્વયંસેવા',
    'મૂવીઝ જોવા',
    'કસરત',
    'લેખન',
    'યોગ',
  ],
  [SupportedLanguage.Bengali]: [
    'ব্যাডমিন্টন',
    'বাস্কেটবল',
    'কোডিং',
    'রান্না',
    'ক্রাফটিং',
    'ক্রিকেট',
    'নাচ',
    'ফুটবল',
    'গার্ডেনিং',
    'হ্যান্ডিক্রাফট',
    'হাইকিং',
    'সঙ্গীত শোনা',
    'চিত্রাঙ্কন',
    'ফটোগ্রাফি',
    'ভিডিও গেম খেলা',
    'পড়া',
    'গান গাওয়া',
    'খেলা',
    'টেনিস',
    'ভ্রমণ',
    'ট্রেকিং',
    'স্বেচ্ছাসেবক কাজ',
    'চলচ্চিত্র দেখা',
    'ব্যায়াম করা',
    'লেখা',
    'যোগ',
  ],
  [SupportedLanguage.Telugu]: [
    'బ్యాడ్మింటన్',
    'బాస్కెట్‌బాల్',
    'కోడింగ్',
    'వంటకాలు',
    'శిల్పకళ',
    'క్రికెట్',
    'నృత్యం',
    'ఫుట్బాల్',
    'తోటముట',
    'హస్తకళ',
    'పర్వతయాత్ర',
    'సంగీతం వినడం',
    'చిత్రకళ',
    'ఫోటోగ్రఫీ',
    'వీడియో గేమ్స్ ఆడటం',
    'చదవడం',
    'పాడడం',
    'క్రీడలు',
    'టెన్నిస్',
    'ప్రయాణం',
    'పర్వతారోహణ',
    'స్వచ్ఛంద సేవ',
    'సినిమాలు చూడడం',
    'వ్యాయామం చేయడం',
    'వ్రాయడం',
    'యోగా',
  ],
  [SupportedLanguage.Kannada]: [
    'ಬ್ಯಾಡ್ಮಿಂಟನ್',
    'ಬ್ಯಾಸ್ಕೆಟ್ಬಾಲ್',
    'ಕೋಡಿಂಗ್',
    'ಅಡುಗೆ',
    'ಕಲಾಕಾರ್ಯ',
    'ಕ್ರಿಕೆಟ್',
    'ನೃತ್ಯ',
    'ಫುಟ್ಬಾಲ್',
    'ತೋಟಗಾರಿಕೆ',
    'ಹಸ್ತಕಲಾ',
    'ಪರ್ವತಾರೋಹಣ',
    'ಸಂಗೀತ ಕೇಳುವುದು',
    'ಚಿತ್ರಕಲೆ',
    'ಫೋಟೋಗ್ರಫಿ',
    'ವೀಡಿಯೋ ಗೇಮ್‌ಗಳನ್ನು ಆಡುವುದು',
    'ವಾಚನ',
    'ಹಾಡುವುದು',
    'ಕ್ರೀಡೆ',
    'ಟೆನ್ನಿಸ್',
    'ಪ್ರಯಾಣ',
    'ಟ್ರೆಕ್ಕಿಂಗ್',
    'ಸ್ವಯಂ ಸೇವೆ',
    'ಚಿತ್ರಗಳನ್ನು ವೀಕ್ಷಿಸುವುದು',
    'ವ್ಯಾಯಾಮ',
    'ಲೇಖನ',
    'ಯೋಗ',
  ],
  [SupportedLanguage.Tamil]: [
    'பேட்மின்டன்',
    'பாஸ்கெட்பால்',
    'கோடிங்',
    'சமையல்',
    'கிராப்டிங்',
    'கிரிக்கெட்',
    'நாட்சம்',
    'பூட்பால்',
    'தோட்டம்',
    'கைசெய்திகள்',
    'மலையாத்திரை',
    'இசையை கேளுதல்',
    'ஓவியம்',
    'புகைப்படம்',
    'வீடியோ விளையாட்டுகள்',
    'படிக்க',
    'பாடுதல்',
    'விளையாடுதல்',
    'டென்னிஸ்',
    'பயணம்',
    'டிரெக்கிங்',
    'சுயமசேவை',
    'திரைப்படங்களை பார்க்க',
    'உடல் எழுதல்',
    'எழுதுதல்',
    'யோகா',
  ],
  [SupportedLanguage.Odia]: [
    'ବ୍ୟାଡମିନ୍ଟନ୍‌',
    'ବାସକେଟ୍‌ବଲ୍‌',
    'କୋଡିଂ',
    'ରନ୍ଧଣା',
    'ଶିଳ୍ପକୃତି',
    'କ୍ରିକେଟ୍‌',
    'ନାଚ',
    'ଫୁଟବଲ୍‌',
    'ବାଗବାନୀ',
    'ହସ୍ତଶିଳ୍ପ',
    'ପାହାଡ଼ ଆରୋହଣ',
    'ସଙ୍ଗୀତ ଶୁଣିବା',
    'ଚିତ୍ରକଳା',
    'ଫଟୋଗ୍ରାଫି',
    'ଭିଡିଓ ଗେମ୍‌ ଖେଳିବା',
    'ପଢ଼ିବା',
    'ଗାଇବା',
    'କ୍ରୀଡ଼ା',
    'ଟେନିସ୍‌',
    'ଭ୍ରମଣ',
    'ପର୍ବତାରୋହଣ',
    'ସ୍ୱେଚ୍ଛାସେବା',
    'ଚଳଚ୍ଚିତ୍ର ଦେଖିବା',
    'ଅଭ୍ୟାସ କରିବା',
    'ଲେଖିବା',
    'ୟୋଗ',
  ],
  [SupportedLanguage.Malayalam]: [
    'ബാഡ്മിന്റൺ',
    'ബാസ്കറ്റ്ബോൾ', 
    'കോഡിംഗ്',
    'പാചകം',
    'കരകൗശലം',
    'ക്രിക്കറ്റ്',
    'നൃത്തം',
    'ഫുട്ബോൾ',
    'കൃഷി',
    'കൈത്തൊഴിൽ',
    'കയറ്റം',
    'സംഗീതം കേൾക്കൽ',
    'ചിത്രരചന',
    'ഫോട്ടോഗ്രഫി',
    'വീഡിയോ ഗെയിമുകൾ',
    'വായന',
    'പാട്ട്',
    'കായികം',
    'ടെന്നീസ്',
    'യാത്ര',
    'ട്രെക്കിംഗ്',
    'സന്നദ്ധസേവനം',
    'സിനിമ കാണൽ',
    'വ്യായാമം',
    'എഴുത്ത്',
    'യോഗ',
  ],
}
